import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesPricingMain } from './modules/ui/Main';

const PricingPage = (
  <SuspensePage>
    <PagesPricingMain />
  </SuspensePage>
);

export default PricingPage;
